import { getTasks } from "./List";
import { getFilter } from "./FilterTasks";

var selectedDate;
var listComponent;
var dayComponents = {};

export function getSelectedDate(element) {
    listComponent.setState({ render: true });
    if (element.state.class.includes("day-selected")) {
        console.log("selected");
        selectedDate = element.props.fulldate;
        filterDataByDate();
    } else {
        console.log("unselected");
        selectedDate = null;
        // console.log(selectedDate);
    }
}

export function dateSelected() {
    // console.log(selectedDate);
    return selectedDate != null;
}

export function renderList() {
    console.log("rendering list");
    filterDataByDate();
    getSelectedDate(dayComponents["Sun"]);
    listComponent.setState({ render: true });
}

export function filterDataByDate(tasks) {
    tasks = getTasks();
    var filteredTasks = [];
    for (var i = 0; i < tasks.length; i++) {
        var task = tasks[i];
        if (task.date === selectedDate) {
            filteredTasks.push(task);
        }
    }
    // return filteredTasks; 
    return formatList(filteredTasks);
}

export function filter() {
    listComponent.setState({ render: true });
    filterData();
}
    

export function filterData() {
    var filter = getFilter();
    var category = filter.category;
    var startDate = filter.dateStart;
    var endDate = filter.dateEnd;
    var startTime = filter.timeStart;
    var endTime = filter.timeEnd;
    console.log(filter);
    var tasks = getTasks();
    if (category != "") {
        console.log("filtering by category");
        for (var i = tasks.length - 1; i >= 0; i--) {
            var task = tasks[i];
            if (task.category != category) {
                tasks.splice(i, 1);
            }
        }
    }
    if (startDate != "" && endDate != "") {
        console.log("filtering by date");
        for (var i = tasks.length - 1; i >= 0; i--) {
            var task = tasks[i];
            if (task.date < startDate || task.date > endDate) {
                tasks.splice(i, 1);
            }
        }
    }
    if (startTime != "" && endTime != "") {
        console.log("filtering by time");
        for (var i = tasks.length - 1; i >= 0; i--) {
            var task = tasks[i];
            if (task.time < startTime || task.time > endTime) {
                tasks.splice(i, 1);
            }
        }
    }
    return formatList(tasks);
}

export function setListComponent(comp) {
    listComponent = comp;
}

export function setDayComponent(comp, day) {
    dayComponents[day] = comp;
}

function formatList(tasks) {
    var listItems = [];
    for (var i = 0; i < tasks.length; i++) {
        var task = tasks[i];
        // convert task date to format like "Feb 1"
        var date = new Date(task.date + "T00:00:00");
        var month = date.toLocaleString('default', { month: 'short' });
        var day = date.getDate();
        task.date = month + " " + day;
        listItems.push(task);
    }
    return listItems;
}

export function clearSelection() {
    var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
    // console.log(dayComponents[days[0]].state);
    for (var i = 0; i < 7; i++) {
        if (dayComponents[days[i]].state.class.includes("day-selected")) {
            if (dayComponents[days[i]].state.class.includes("today")) {
                dayComponents[days[i]].setState({ class: "today " });
            } else {
                dayComponents[days[i]].setState({ class: "" });
            }
        }
    }
    selectedDate = null;
    listComponent.setState({ render: true });
}

export function checkCircles() {
    // get todays date
    // Q: how to wait until Week component is rendered?
    // A: use a callback function
    // https://stackoverflow.com/questions/37999991/how-to-wait-for-a-react-component-to-render
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    today = yyyy + '-' + mm + '-' + dd;

    var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]

    var dates = document.getElementsByClassName("date");
    // save the innerHTML of the dates
    dates = Array.from(dates).map(function (element) {
        return element.innerHTML;
    });
    console.log(dates);
    for (var i = 0; i < 7; i++) {
        var date = dayComponents[days[i]].props.fulldate;
        console.log(date);
        if (date === today) {
            dayComponents[days[i]].setState({ class: "today " });
        } else {
            dayComponents[days[i]].setState({ class: "" });
        }
        if (date === selectedDate) {
            dayComponents[days[i]].setState({ class: dayComponents[days[i]].state.class + "day-selected " });
        } else if (dayComponents[days[i]].state.class.includes("day-selected")) {
            dayComponents[days[i]].setState({ class: dayComponents[days[i]].state.class.replace("day-selected", "") });
        }
    }
}